import { render, staticRenderFns } from "./updHsbc.vue?vue&type=template&id=267b65c8"
import script from "./updHsbc.vue?vue&type=script&lang=js"
export * from "./updHsbc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports